<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="1200px">
      <v-card>
        <v-form @submit="onSubmit" ref="form" v-model="isFormValid">
        <v-card-title>
          <span class="text-h5">Ret Kunde</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="customerName"
                  label="Kundenavn*"
                  required
                  :counter="50"
                  :rules="textFieldRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="contactName"
                  label="Kontaktpersonens navn*"
                  required
                  counter="50"
                  :rules="textFieldRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                    v-model="contactEmail"
                    label="Kontaktpersonens e-mail*"
                    required
                    type="email"
                    counter="50"
                    :rules="emailRules">{{ }}</v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                    v-model="contactPhone"
                    label="Kontaktpersonens telefonnummer*"
                    required
                    type="tel"
                    counter="50"
                    :rules="textFieldRules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="createdBy"
                  label="Oprettet af"
                  disabled
                >createdBy</v-text-field>
                <v-text-field
                  v-model="updatedBy"
                  label="Rettet af*"
                  required
                  counter="50"
                  :rules="textFieldRules"
                >updatedBy</v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="validUntil"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="validUntil"
                      label="Gældende indtil"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="validUntil" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(validUntil)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
          <small>* indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn
            type="submit"
            color="blue darken-1"
            text
            :disabled="isSubmitDisabled || !isFormValid"
          >
            Save
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    menu: false,
    validUntil: new Date(),
    customerName: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    createdBy: "",
    updatedBy: "",
    accessAll: false,
    apiKey: "",
    customerID: 0,
    dialog: false,
    isSubmitDisabled: false,
    isFormValid: false,
    selectedSiteIDs: [],
    sitesData: [],
    siteSelecter: [],
    textFieldRules: [
      value => {
        if (value) return true

        return 'Dette felt er påkrævet'
      },
    ],
    emailRules: [
      value => {
        if (value) return true

        return 'E-mail er påkrævet'
      },
      value => {
        if (/.+@.+\..+/.test(value)) return true

        return 'E-mail skal være gyldig'
      },
    ],
  }),
  methods: {
    onSubmit() {
      event.preventDefault();
      if (!this.$refs.form.validate()) return;
      this.isSubmitDisabled = true;

      let validUntilString =
        this.validUntil.substring(0, 4) +
        this.validUntil.substring(5, 7) +
        this.validUntil.substring(8, 10);

      const customer = [ 
        {
          customerName: this.customerName,
          contactName: this.contactName,
          contactEmail: this.contactEmail,
          contactPhone: this.contactPhone,
          validUntil: validUntilString,
          createdByUser: this.createdBy,
          updatedByUser: this.updatedBy,
          apiKey: this.apiKey,
          customerID: this.customerID,
          accessAll: this.accessAll,
          apiAccess: this.apiAccess
        },
      ];

      axios
        .patch(
          process.env.VUE_APP_BASEURL_EXTERNALAPI +
            "/Admin/EditExternalUsers",
          customer,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("EK-Token3"),
            },
          }
        )
        .then((response) => {
          this.selectedSiteIDs.forEach((dto) => {
            dto.ExternalCustomerID = response.data.successObjects[0].customerID;
          });
        })
        .then(() => {
          this.$root.$emit("customerUpdated");
          this.dialog = false;
          this.clearForm();
        })
        .catch((error) => {
          const defaultErrorMessage = "Der er sket en fejl. Prøv igen senere.";

          const extractErrorMessages = (errors) => Object.values(errors).flat().join('\n');

          const getMessage = () => {
            if (!error.response || !error.response.status) return defaultErrorMessage;

            switch (error.response.status) {
              case 400:
                return error.response.data && error.response.data.errors
                    ? extractErrorMessages(error.response.data.errors)
                    : defaultErrorMessage;
              case 401:
                return "Du er ikke logget ind. Log ind og prøv igen.";
              default:
                return defaultErrorMessage;
            }
          };

          alert(getMessage());
        })
        .finally(() => {
          this.isSubmitDisabled = false;
        });
    },
    clearForm() {
      this.customerName = "";
      this.contactName = "";
      this.contactEmail = "";
      this.contactPhone = "";
      this.createdBy = "";
      this.updatedBy = "";
      this.accessAll = false;
      this.selectedSiteIDs = [];
    },
    parseDateToCorrectTimeZone(dateString) {
      const date = new Date(dateString);

      return new Date(date - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substring(0, 10);
    },
    mapData(customerData) {
      this.customerName = customerData.customerName,
      this.contactName = customerData.contactName,
      this.contactEmail = customerData.contactEmail,
      this.contactPhone = customerData.contactPhone,
      this.validUntil = this.parseDateToCorrectTimeZone(customerData.validUntil),
      this.createdBy = customerData.createdByUser,
      this.apiKey = customerData.apiKey,
      this.customerID = customerData.customerID,
      this.accessAll = customerData.accessAll
    },
    fetchCustomerByID(id) {
      axios
        .get(process.env.VUE_APP_BASEURL_EXTERNALAPI + "/admin/customers", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("EK-Token3"),
          },
          params: {
            id: id,
          },
        })
        .then((response) => {
          this.mapData(response.data.data[0]);
          this.dialog = true;
        });
    },
  },
};
</script>